import React, { useState, useRef, useEffect } from "react";
import {
  IconX,
  IconArrowsExchange,
  IconUserPlus,
  IconTag,
  IconTrash,
  IconDownload,
} from "@tabler/icons-react";
import Swal from "sweetalert2";
import { useCRM } from "../CRMContext";
import { bulkMoveContacts, bulkAssignContacts, bulkTagContacts, bulkDeleteContacts, exportContacts } from "../services/contacts.service";

const BulkActionsBar = () => {
  const { state, clearSelection, removeContactsFromColumns, refreshBoard, showToast } = useCRM();
  const { selectedContacts, columns, teamMembers } = state;

  const [moveOpen, setMoveOpen] = useState(false);
  const [assignOpen, setAssignOpen] = useState(false);
  const moveRef = useRef(null);
  const assignRef = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (moveRef.current && !moveRef.current.contains(e.target)) setMoveOpen(false);
      if (assignRef.current && !assignRef.current.contains(e.target)) setAssignOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  if (selectedContacts.length === 0) return null;

  const handleBulkMove = async (columnId) => {
    setMoveOpen(false);
    try {
      await bulkMoveContacts(selectedContacts, columnId);
      showToast(`${selectedContacts.length} contatos movidos!`);
      clearSelection();
      refreshBoard();
    } catch {
      showToast("Erro ao mover contatos.", "error");
    }
  };

  const handleBulkAssign = async (ownerId) => {
    setAssignOpen(false);
    try {
      await bulkAssignContacts(selectedContacts, ownerId);
      showToast(`${selectedContacts.length} contatos atualizados!`);
      clearSelection();
      refreshBoard();
    } catch {
      showToast("Erro ao atribuir responsável.", "error");
    }
  };

  const handleBulkDelete = async () => {
    const result = await Swal.fire({
      title: "Confirmar exclusão",
      text: `Deseja excluir ${selectedContacts.length} contatos selecionados?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ef4444",
    });

    if (result.isConfirmed) {
      try {
        await bulkDeleteContacts(selectedContacts);
        removeContactsFromColumns(selectedContacts);
        showToast(`${selectedContacts.length} contatos excluídos!`);
      } catch {
        showToast("Erro ao excluir contatos.", "error");
      }
    }
  };

  const handleBulkExport = async () => {
    try {
      await exportContacts({}, selectedContacts);
      showToast("Contatos exportados com sucesso!");
    } catch {
      showToast("Erro ao exportar.", "error");
    }
  };

  return (
    <div className="crm-bulk-bar">
      <span className="crm-bulk-bar__count">{selectedContacts.length} selecionados</span>
      <div className="crm-bulk-bar__divider" />

      <div className="crm-bulk-bar__actions">
        {/* Move */}
        <div style={{ position: "relative" }} ref={moveRef}>
          <button className="crm-bulk-bar__btn" onClick={() => setMoveOpen(!moveOpen)}>
            <IconArrowsExchange size={16} /> Mover
          </button>
          {moveOpen && (
            <div className="crm-dropdown" style={{ bottom: "100%", top: "auto", marginBottom: 4, right: "auto", left: 0 }}>
              {columns.map((col) => (
                <button key={col.id} className="crm-dropdown__item" onClick={() => handleBulkMove(col.id)}>
                  <span style={{ width: 10, height: 10, borderRadius: 3, background: col.color || "#3b82f6" }} />
                  {col.name}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Assign */}
        <div style={{ position: "relative" }} ref={assignRef}>
          <button className="crm-bulk-bar__btn" onClick={() => setAssignOpen(!assignOpen)}>
            <IconUserPlus size={16} /> Atribuir
          </button>
          {assignOpen && (
            <div className="crm-dropdown" style={{ bottom: "100%", top: "auto", marginBottom: 4, right: "auto", left: 0 }}>
              <button className="crm-dropdown__item" onClick={() => handleBulkAssign(null)}>
                Remover responsável
              </button>
              {teamMembers.map((m) => (
                <button key={m.id} className="crm-dropdown__item" onClick={() => handleBulkAssign(m.id)}>
                  {m.first_name} {m.last_name}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Export */}
        <button className="crm-bulk-bar__btn" onClick={handleBulkExport}>
          <IconDownload size={16} /> Exportar
        </button>

        {/* Delete */}
        <button className="crm-bulk-bar__btn crm-bulk-bar__btn--danger" onClick={handleBulkDelete}>
          <IconTrash size={16} /> Excluir
        </button>
      </div>

      <button className="crm-bulk-bar__close" onClick={clearSelection}>
        <IconX size={18} />
      </button>
    </div>
  );
};

export default BulkActionsBar;
